// extracted by mini-css-extract-plugin
var _1 = "ColorRoot_inherit__eaafe";
var _2 = "ColorRoot_label__2e6a9";
var _3 = "ColorRoot_root__6e7b0";
export { _1 as "inherit", _2 as "label", _3 as "root" }
